import { render, staticRenderFns } from "./SettlementSavingsDialog.vue?vue&type=template&id=106f236a&scoped=true"
import script from "./SettlementSavingsDialog.vue?vue&type=script&lang=js"
export * from "./SettlementSavingsDialog.vue?vue&type=script&lang=js"
import style0 from "./SettlementSavingsDialog.vue?vue&type=style&index=0&id=106f236a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f236a",
  null
  
)

export default component.exports